import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import RelifLogo from 'assets/images/logos/RelifLogoAzul.png';
import { Link, useSearchParams } from 'react-router-dom';
import { NAVY, RADIUS_CARD, RADIUS_COIN, SHADOW, SURFACE, SURFACE_CONTAINER_LOWEST, YELLOW } from 'styles/tokens';

import DECKS from './decks';

const OWNERS = [...new Set(DECKS.map((deck) => deck.owner))].sort();

const OwnerFilter = ({ label, to, selected }: { label: string; to: string; selected: boolean }) => (
  <Box
    component={Link}
    to={to}
    sx={{
      px: 2,
      py: 0.75,
      borderRadius: RADIUS_COIN,
      fontSize: '0.95rem',
      fontWeight: 500,
      textDecoration: 'none',
      color: NAVY,
      bgcolor: selected ? YELLOW : SURFACE_CONTAINER_LOWEST,
      '&:hover': { bgcolor: selected ? YELLOW : alpha(NAVY, 0.06) },
    }}
  >
    {label}
  </Box>
);

const Presentations = () => {
  const [searchParams] = useSearchParams();
  const owner = searchParams.get('owner')?.toLowerCase();
  const decks = owner ? DECKS.filter((deck) => deck.owner.toLowerCase() === owner) : DECKS;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: SURFACE, px: { xs: 3, md: 8 }, py: 8 }}>
      <Stack spacing={5} sx={{ maxWidth: 880, mx: 'auto' }}>
        <Stack spacing={2.5}>
          <Box component="img" src={RelifLogo} alt="Relif" sx={{ height: 26, alignSelf: 'flex-start' }} />
          <Typography sx={{ fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.1, color: NAVY }}>
            Presentaciones
          </Typography>
          <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 1, pt: 0.5 }}>
            <OwnerFilter label="Todas" to="/presentations" selected={!owner} />
            {OWNERS.map((name) => (
              <OwnerFilter
                key={name}
                label={name}
                to={`/presentations?owner=${name}`}
                selected={owner === name.toLowerCase()}
              />
            ))}
          </Stack>
        </Stack>

        <Stack spacing={1.5}>
          {decks.map((deck) => (
          <Box
            key={deck.slug}
            component={Link}
            to={`/presentations/${deck.slug}`}
            sx={{
              display: 'block',
              px: 3,
              py: 2.5,
              borderRadius: RADIUS_CARD,
              bgcolor: SURFACE_CONTAINER_LOWEST,
              textDecoration: 'none',
              transition: 'box-shadow 0.2s, transform 0.2s',
              '&:hover': { boxShadow: SHADOW, transform: 'translateY(-2px)' },
            }}
          >
              <Typography sx={{ fontWeight: 600, fontSize: '1.25rem', color: NAVY }}>{deck.title}</Typography>
              <Typography sx={{ fontSize: '0.95rem', color: alpha(NAVY, 0.45) }}>
                {deck.owner} · /presentations/{deck.slug}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};

export default Presentations;
